define(function(require,exports,module){
    var PitchRaster = require( "./PitchRaster" ),
        min     = Math.min,
        power   = Math.pow;


    function PitchVector(pitch,renderer){
        this.pitch=pitch;
        this.renderer=renderer;
    }
    PitchRaster.spawn(PitchVector).define({
        curve : function() {
            var scalers=this.renderer.scalers;
            //f(x)=Ax2+Bx+Cf(x)=Ax2+Bx+C
            //this.coords[p0] + (this.coords[vp0] * t) + ((0.5 * this.coords[ap]) * (t * t)))
            //x1 = positionAt start and x2 - position at End
            //P1=(x1,f(x1))P1=(x1,f(x1))  and P2=(x2,f(x2))P2=(x2,f(x2)) 
            console.info(this.pitch)
            return 'M 100 100' +[
                ' q' + [ this.pitch.az, this.pitch.ax, 0, this.pitch.x].join(', ')
            ].join(', ');
        },
        width : function(){
            var scalers=this.renderer.scalers;
            return min(power((scalers.fakeBallSize) / (this.pitch.startSpeed - this.pitch.endSpeed) / 1 * power(1, 2), 0.7), scalers.maxlinewidth * 1.8);
        }
    });
    return PitchVector;
});